const isBrowser = typeof window !== "undefined";

const isValid = (v) => {
  if (!v) return false;
  // reject anything with unmatched or placeholder percent signs or template markers
  if (v.includes("%%")) return false;
  if (v.startsWith("%") || v.endsWith("%")) return false;
  if (v.startsWith("%%") || v.endsWith("%%")) return false;
  return true;
};

export const getEnvName = () => {
  if (isBrowser && window._env_ && isValid(window._env_.ENV_NAME)) {
    return window._env_.ENV_NAME;
  }
  return process.env.REACT_APP_ENV_NAME;
};

export const getBackendUrl = () => {
  if (isBrowser && window._env_ && isValid(window._env_.BACKEND_URL)) {
    return window._env_.BACKEND_URL;
  }
  return process.env.REACT_APP_JAVA_API_URL;
};

export const getPythonApiUrl = () => {
  if (isBrowser && window._env_ && isValid(window._env_.PYTHON_API_URL)) {
    return window._env_.PYTHON_API_URL;
  }
  return process.env.REACT_APP_PYTHON_API_URL;
};

export const getPublicPosthogUrl = () => {
    if (isBrowser && window._env_ && isValid(window._env_.PUBLIC_POSTHOG_URL)) {
    return window._env_.PUBLIC_POSTHOG_URL;
  }
  return process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
};

export const getPublicPosthogKey = () => {
  if (isBrowser && window._env_ && isValid(window._env_.PUBLIC_POSTHOG_KEY)) {
    return window._env_.PUBLIC_POSTHOG_KEY;
  }
  return process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
};